module.exports = __webpack_public_path__ + "static/media/F2.5e4f631e.webp";